<template>
<div>
  <div style="padding:20px;">
    <a href="/" title="Home"><img src="/images/logo.svg" width="246" height="42" alt="" class="header-logo"></a>
  </div>
  <div style="max-width:1320px;margin:auto;padding:10px 20px 0;" v-if="is_loaded">
    <div class="pta-investor-profile-head">
      <h1><br />{{ user.profile.company }}</h1>
      <!-- <img src="/images/logo_profile.svg" /> -->
      <ul class="mm-links">
        <li><a :href="'/fs2/'+user.id+'/pdf'" class="mm-link-pdf">PDF</a></li>
        <li><a :href="'/fs/'+user.id+'/doc'" class="mm-link-word">Word</a></li>
      </ul>
    </div>
    <div class="pta-investor-profile" style="padding-top:40px;">
      <div class="pta-investor-profile-left">
        <div class="pta-investor-profile-box">
          <h3>About the Manager / Sponsor</h3>
          <div class="pta-investor-profile-box-content" style="text-align:center;" v-html="typeValueSponsors">
           <!-- {{ user.profile.company_description?user.profile.company_description:'No general description available.' }} -->
          </div>
        </div>
        <div class="pta-investor-profile-box">
          <h3>Key Differentiators / Track Record Highlights</h3>
          <div class="pta-investor-profile-box-content" v-html="typeValueTR"></div>
          <!-- <div class="pta-factsheet-box-content" v-if="user.profile.track_record_1 || user.profile.track_record_2 || user.profile.track_record_3 || user.profile.track_record_4">
            <ul>
              <li v-if="user.profile.track_record_1">{{ user.profile.track_record_1 }}</li>
              <li v-if="user.profile.track_record_2">{{ user.profile.track_record_2 }}</li>
              <li v-if="user.profile.track_record_3">{{ user.profile.track_record_3 }}</li>
              <li v-if="user.profile.track_record_4">{{ user.profile.track_record_4 }}</li>
            </ul>
          </div>
          <div class="pta-factsheet-box-content" style="text-align:center;" v-else>
            No information available.
          </div> -->
        </div>
      </div>
      <div class="pta-investor-profile-right">
        <div class="pta-investor-profile-box">
          <h3>About the Offering</h3>
          <div class="pta-investor-profile-box-content" style="text-align:center;" v-html="typeValueOffer">
            <!-- {{ user.profile.strategy?user.profile.strategy:'No information available.' }} -->
          </div>
        </div>
        <div class="pta-investor-profile-box">
          <h3>Key Terms</h3>
          <div class="pta-investor-profile-box-content" v-html="typeValueTerms">
            <!-- <table cellpadding="0" cellspacing="0" width="100%">
              <tr><td>Asset Class</td>
                <td v-if="user.profile.fund_type.name">
                  {{ user.profile.fund_type.name }}
                </td><td v-else>-</td></tr>
              <tr><td>Target Returns</td><td>
                IRR % {{ user.profile.irr }} percent IRR / Equity Multiple / MOIC (x) {{ user.profile.moic }}x (Cash-on-Cash)
              </td></tr>
              <tr><td>Structure and Vehicle Domiciliation</td><td>{{ user.profile.inv_struct }}</td></tr>
              <tr><td>Geographical Focus</td><td v-if="user.profile.asset_countries.length"><span v-for="asset_country in user.profile.asset_countries">{{ asset_country.name }}</span></td><td v-else>-</td></tr>
              <tr><td>Target Volume</td><td>{{ user.profile.total_capital?user.profile.total_capital+'m':'-' }}</td></tr>
              <tr><td>Holding Period</td><td>{{ user.profile.holding_period?user.profile.holding_period+' year(s)':'-' }}</td></tr>
              <tr><td>Minimum Commitment Size</td><td>{{ user.profile.ticket_size?user.profile.ticket_size+'m':'-' }}</td></tr>
              <tr><td>Are we a member of any ESG associations?</td><td>{{ user.profile.esg }}</td></tr>
            </table> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  components : {  },
  data() {
    return {
      alias:this.$route.params.alias,
      is_loaded: false,
      user:'',
      typeValueSponsors: "Waiting for AI output ...",
      typeStatusSponsors: false,
      charIndexSponsors: 0,
      typeValueOffer: "Waiting for AI output ...",
      typeStatusOffer: false,
      charIndexOffer: 0,
      typeValueTR: "<center>Waiting for AI output ...</center>",
      typeStatusTR: false,
      charIndexTR: 0,
      typeValueTerms: "<center>Waiting for AI output ...</center>",
      typeStatusTerms: false,
      charIndexTerms: 0,
      typingSpeed: 30,
      content_tr: ''
    };
  },
  mounted(){
    this.fetchUserData();
  },
  methods: {
    fetchUserData(){
      axios.get('/api/user-by-alias/'+this.alias)
          .then(response => response.data)
          .then(response => {
            this.user = response.user;
            this.is_loaded = true;
            this.typeValueSponsors = "";

            if(this.user.profile.track_record_1 || this.user.profile.track_record_2 || this.user.profile.track_record_3 || this.user.profile.track_record_4){
              this.content_tr += '<ul>';
              if(this.user.profile.track_record_1) {
                this.content_tr += '<li>'+this.user.profile.track_record_1+'</li>';
              }
              if(this.user.profile.track_record_2) {
                this.content_tr += '<li>'+this.user.profile.track_record_2+'</li>';
              }
              if(this.user.profile.track_record_3) {
                this.content_tr += '<li>'+this.user.profile.track_record_3+'</li>';
              }
              if(this.user.profile.track_record_4) {
                this.content_tr += '<li>'+this.user.profile.track_record_4+'</li>';
              }
              this.content_tr += '</ul>';
            }else{
              this.content_tr = 'No information available.';
            }

            if (!this.user.profile.strategy) {
              this.user.profile.strategy = "No information available."
            }
            if (!this.user.profile.company_description) {
              this.user.profile.company_description = "No information available."
            }

            this.content_terms = '<table cellPadding="0" cellSpacing="0" width="100%">';
            this.content_terms += '<tr><td>Asset Class</td><td>'+(this.user.profile.fund_type.name?this.user.profile.fund_type.name:'-')+'</td></tr>';
            this.content_terms += '<tr><td>Target Returns</td><td>IRR % '+this.user.profile.irr+' percent IRR / Equity Multiple / MOIC (x) '+this.user.profile.moic+'x(Cash-on-Cash)</td></tr>';
            this.content_terms += '<tr><td>Structure and Vehicle Domiciliation</td><td>'+this.user.profile.inv_struct+'</td></tr>';
            this.content_terms += '<tr><td>Geographical Focus</td><td>'+(this.user.profile.asset_countries.length?'-':'-')+'</td></tr>';
            this.content_terms += '<tr><td>Target Volume</td><td>'+(this.user.profile.total_capital ? this.user.profile.total_capital + 'm' : '-')+'</td></tr>';
            this.content_terms += '<tr><td>Holding Period</td><td>'+(this.user.profile.holding_period ? this.user.profile.holding_period + ' year(s)' : '-')+'</td></tr>';
            this.content_terms += '<tr><td>Minimum Commitment Size</td><td>'+(this.user.profile.ticket_size ? this.user.profile.ticket_size + 'm' : '-')+'</td></tr>';
            this.content_terms += '<tr><td>Are we a member of any ESG associations?</td><td>'+this.user.profile.esg+'</td></tr>';
            this.content_terms += '</table>';

            this.typeTextSponsors();
          })
          .catch(error => {
            helper.showDataErrorMsg(error);
          })
    },
    typeTextSponsors() {
      if (this.user.profile.strategy && this.charIndexSponsors < this.user.profile.strategy.length) {
        if (!this.typeStatusSponsors) this.typeStatusSponsors = true;
        this.typeValueSponsors += this.user.profile.strategy.charAt(
            this.charIndexSponsors
        );
        this.charIndexSponsors += 1;
        setTimeout(this.typeTextSponsors, this.typingSpeed);
      }else{
        this.typeValueOffer = "";
        setTimeout(this.typeTextOffer, this.typingSpeed);
      }
    },
    typeTextOffer() {
      if (this.user.profile.company_description && this.charIndexOffer < this.user.profile.company_description.length) {
        if (!this.typeStatusOffer) this.typeStatusOffer = true;
        this.typeValueOffer += this.user.profile.company_description.charAt(
            this.charIndexOffer
        );
        this.charIndexOffer += 1;
        setTimeout(this.typeTextOffer, this.typingSpeed);
      }else{
        this.typeValueTR = "";
        setTimeout(this.typeTextTR, this.typingSpeed);
      }
    },
    typeTextTR() {
      if (this.content_tr && this.charIndexTR < this.content_tr.length) {
        if (!this.typeStatusTR) this.typeStatusTR = true;
        this.typeValueTR += this.content_tr.charAt(
            this.charIndexTR
        );
        this.charIndexTR += 1;
        setTimeout(this.typeTextTR, this.typingSpeed);
      }else{
        this.typeValueTerms = "";
        setTimeout(this.typeTextTerms, this.typingSpeed);
      }
    },
    typeTextTerms() {
      if (this.content_terms && this.charIndexTerms < this.content_terms.length) {
        if (!this.typeStatusTerms) this.typeStatusTerms = true;
        this.typeValueTerms += this.content_terms.charAt(
            this.charIndexTerms
        );
        this.charIndexTerms += 1;
        setTimeout(this.typeTextTerms, this.typingSpeed);
      }
    },
  },

  filters: {
    moment(date) {
      return helper.formatDate(date);
    },
    momentDateTime(date) {
      return helper.formatDateTime(date).replace(" "," at ");
    }
  }
}
</script>